/* eslint-disable no-useless-concat */
import { Grid, Typography } from "@material-ui/core"
import { ReactNode } from "react"
import { drillDownStyles } from "../../../styles"

export function TitleWithFilters({
  children,
  title,
}: {
  children: ReactNode
  title: string
}) {
  return (
    <Grid
      container
      justify="space-between"
      style={{
        position: "relative",
        marginBottom: "64px",
      }}
    >
      <Typography align="left" className={drillDownStyles.drillDownTitle}>
        {title}
      </Typography>
      {children}
    </Grid>
  )
}
